import React from 'react';
import {
    Dialog,
    DialogTitle,
    IconButton,
    Typography,
    Box,
    DialogContent,
    Snackbar,
    Fade,
    Grid
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import JsonViewer from './JsonViwer';
import useClipboard from '../hooks/useClipboard';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    title: string;
    did: string;
    doc: object | null;
}

const Modal: React.FC<ModalProps> = ({ open, onClose, title, did, doc }) => {
    const { snackBarState, copyToClipboard, handleClose } = useClipboard();

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle disableTypography style={{ padding: '16px 24px 0px' }}>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Typography style={{ fontWeight: 600, fontSize: '1rem' }}>{title}</Typography>
                    <IconButton size="small" onClick={onClose}>
                        <CloseIcon style={{ fontSize: 18 }} />
                    </IconButton>
                </Box>
                <Grid container alignItems="center" spacing={3}>
                    <Grid item xs>
                        <Typography
                            variant="caption"
                            style={{
                                color: '#888',
                                wordBreak: 'break-all',
                                display: 'block'
                            }}>
                            {did}
                        </Typography>
                    </Grid>
                    {doc && (
                        <Grid item>
                            <IconButton
                                size="small"
                                onClick={() => copyToClipboard(JSON.stringify(doc))}
                                style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: 6,
                                    padding: 6,
                                    backgroundColor: '#fff'
                                }}>
                                <FileCopyOutlinedIcon style={{ fontSize: 16, color: '#555' }} />
                            </IconButton>
                        </Grid>
                    )}
                </Grid>
            </DialogTitle>
            <DialogContent>
                {doc && (
                    <>
                        <JsonViewer content={doc} />
                    </>
                )}
            </DialogContent>
            <Snackbar
                open={snackBarState.open}
                onClose={handleClose}
                TransitionComponent={Fade}
                message={snackBarState.text}
                autoHideDuration={5000}
            />
        </Dialog>
    );
};

export default Modal;
